export const SET_MESSAGES = "SET_MESSAGES";
export const MARK_MESSAGE_AS_READ = "MARK_MESSAGE_AS_READ";
